/* One Piece kiezer v2.
   Klik op een tegel = in je selectie, nog eens = eruit. De laatst aangeklikte kleur staat groot in beeld.
   De selectie staat in sessionStorage onder sfOpPicked, dezelfde sleutel als de productpagina,
   zodat een keuze op de ene pagina op de andere terugkomt. */
(function () {
  if (window.sfOnePieceV2Init) return;
  window.sfOnePieceV2Init = true;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents, symbol) {
    var v = (cents / 100).toFixed(2).replace('.', ',');
    return (symbol || '€') + ' ' + v;
  }
  function fmt(tpl, vars) {
    return String(tpl || '').replace(/\{(\w+)\}/g, function (m, k) { return vars[k] != null ? vars[k] : m; });
  }
  function cartElement() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  /* Zelfde route als het productformulier van het thema: eerst de lade of melding vullen,
     lukt dat niet, dan naar de winkelwagen. */
  function addItems(ids, urls) {
    var cart = cartElement();
    var url = urls.add || '/cart/add';
    if (!/\.js$/.test(url)) url += '.js';
    var chain = Promise.resolve(null);
    ids.forEach(function (id, i) {
      chain = chain.then(function () {
        var body = { id: id, quantity: 1 };
        if (i === ids.length - 1 && cart && typeof cart.getSectionsToRender === 'function') {
          body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
          body.sections_url = window.location.pathname;
        }
        return fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body)
        }).then(function (r) { return r.json(); }).then(function (res) {
          if (res.status) throw new Error(res.description || 'add failed');
          return res;
        });
      });
    });
    return chain.then(function (res) {
      if (cart && res && res.sections && typeof cart.renderContents === 'function') {
        try {
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
          cart.renderContents(res);
          setTimeout(function () {
            if (!cart.classList.contains('active')) window.location.href = urls.cart || '/cart';
          }, 900);
          return;
        } catch (e) { console.error('[sf-onepiece-v2] winkelwagenlade', e); }
      }
      window.location.href = urls.cart || '/cart';
    });
  }

  function busy(btn, fn) {
    btn.classList.add('is-busy');
    var p;
    try { p = Promise.resolve(fn()); } catch (e) { p = Promise.reject(e); }
    p.catch(function (e) { console.error('[sf-onepiece-v2] toevoegen mislukt', e); window.location.href = '/cart'; })
      .then(function () { btn.classList.remove('is-busy'); });
  }

  function init() {
    var root = document.querySelector('[data-sf-onepiece-v2]');
    if (!root || root.hasAttribute('data-sf-ready')) return;
    root.setAttribute('data-sf-ready', '');

    var urls = { add: root.getAttribute('data-add-url'), cart: root.getAttribute('data-cart-url') };
    var sym = root.getAttribute('data-currency') || '€';
    var L = {
      add: root.getAttribute('data-add-label') || 'Voeg toe aan selectie',
      remove: root.getAttribute('data-remove-label') || 'Haal uit selectie',
      cart: root.getAttribute('data-cart-label') || 'In winkelwagen · {n} samples',
      cartOne: root.getAttribute('data-cart-one-label') || '',
      cartEmpty: root.getAttribute('data-cart-empty-label') || 'Kies eerst een kleur',
      liveAdded: root.getAttribute('data-live-added') || '{name} toegevoegd. {n} in je selectie.',
      liveRemoved: root.getAttribute('data-live-removed') || '{name} verwijderd. {n} in je selectie.'
    };

    var tabs = root.querySelectorAll('[data-op2-tab]');
    var grids = root.querySelectorAll('[data-op2-grid]');
    var swatches = root.querySelectorAll('[data-op2-swatch]');
    var photo = root.querySelector('[data-op2-photo]');
    var photoPh = root.querySelector('[data-op2-photo-ph]');
    var photoState = root.querySelector('[data-op2-photo-state]');
    var nameEl = root.querySelector('[data-op2-name]');
    var metaEl = root.querySelector('[data-op2-meta]');
    var noteEl = root.querySelector('[data-op2-note]');
    var edgeEl = root.querySelector('[data-op2-edge]');
    var detailEl = root.querySelector('[data-op2-detail]');
    var priceEl = root.querySelector('[data-op2-price]');
    var toggleBtn = root.querySelector('[data-op2-toggle]');
    var toggleLabel = root.querySelector('[data-op2-toggle-label]');
    var list = root.querySelector('[data-op2-list]');
    var countEl = root.querySelector('[data-op2-count]');
    var totalEl = root.querySelector('[data-op2-total]');
    var tipEl = root.querySelector('[data-op2-tip]');
    var cartBtn = root.querySelector('[data-op2-cart]');
    var selection = root.querySelector('[data-op2-selection]');
    var sticky = root.querySelector('[data-op2-sticky]');
    var stCount = root.querySelector('[data-op2-sticky-count]');
    var stTotal = root.querySelector('[data-op2-sticky-total]');
    var stCart = root.querySelector('[data-op2-sticky-cart]');
    var live = root.querySelector('[data-op2-live]');

    var viewing = null;
    var picked = {};
    try { picked = JSON.parse(sessionStorage.getItem('sfOpPicked') || '{}') || {}; } catch (e) { picked = {}; }

    function byId(id) { return root.querySelector('[data-op2-swatch][data-vid="' + id + '"]'); }

    /* Een selectie uit de sessie komt alleen terug als je via 'terug' of vanaf een productpagina op de pagina komt.
       Bij een gewoon bezoek (of nieuwe tab) begin je leeg, anders tel je samples mee die je niet meer ziet. Kleuren
       die niet (meer) op de pagina staan tellen ook niet mee. */
    (function () {
      var nav = (window.performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {};
      var ref = ''; try { ref = new URL(document.referrer).pathname; } catch (e) {}
      var restore = nav.type === 'back_forward' || /^\/([a-z]{2}(-[a-z]{2})?\/)?products\//.test(ref);
      if (!restore) picked = {};
      Object.keys(picked).forEach(function (id) { if (!byId(id)) delete picked[id]; });
      try { sessionStorage.setItem('sfOpPicked', JSON.stringify(picked)); } catch (e) {}
    })();
    function cents(btn) { return parseInt(btn.getAttribute('data-cents'), 10) || 0; }

    /* ---------- tabs ---------- */
    function activateTab(name) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-op2-tab') === name;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      grids.forEach(function (g) { g.classList.toggle('is-on', g.getAttribute('data-op2-grid') === name); });
    }
    /* Tab openen. Staat de kleur in beeld niet in dat tabblad, dan toont het podium de eerste
       kleur ervan, zonder hem toe te voegen. */
    function openTab(name) {
      var grid = root.querySelector('[data-op2-grid="' + name + '"]');
      if (!grid) return;
      activateTab(name);
      if (viewing && grid.contains(viewing)) return;
      var first = grid.querySelector('[data-op2-swatch].is-picked:not([disabled])') || grid.querySelector('[data-op2-swatch]:not([disabled])');
      if (first) view(first);
    }
    tabs.forEach(function (t) {
      t.addEventListener('click', function () { openTab(t.getAttribute('data-op2-tab')); });
    });
    /* Voor de keuzehulp hogerop de pagina: "Ik weet al welke kleuren" en "Werkbladen". */
    root.sfActivateTab = function (name) {
      if (name === 'fronts') {
        var firstTab = root.querySelector('[data-op2-tab="wood"]') || root.querySelector('[data-op2-tab="paint"]');
        name = firstTab ? firstTab.getAttribute('data-op2-tab') : name;
      }
      openTab(name);
    };

    /* ---------- in beeld ---------- */
    function view(btn) {
      viewing = btn;
      swatches.forEach(function (b) { b.classList.toggle('is-view', b === btn); });
      var img = btn.getAttribute('data-img');
      if (img) { photo.src = img; photo.alt = btn.getAttribute('data-name') || ''; photo.hidden = false; photoPh.hidden = true; }
      else { photo.hidden = true; photoPh.hidden = false; }
      nameEl.textContent = btn.getAttribute('data-name') || '';
      var finish = btn.getAttribute('data-finish');
      metaEl.textContent = (btn.getAttribute('data-family') || '') + (finish ? ' · ' + finish : '');
      var note = btn.getAttribute('data-note') || '';
      if (noteEl) { noteEl.textContent = note; noteEl.hidden = !note; }
      if (edgeEl) { var fam = (btn.getAttribute('data-family') || '').toLowerCase(); edgeEl.hidden = fam !== 'paint'; }
      if (detailEl) { var url = btn.getAttribute('data-url'); detailEl.href = url || '#'; detailEl.hidden = !url; }
      syncToggle();
    }

    function syncToggle() {
      if (!viewing) return;
      var isIn = !!picked[viewing.getAttribute('data-vid')];
      toggleBtn.disabled = false;
      toggleBtn.classList.toggle('is-picked', isIn);
      toggleBtn.setAttribute('aria-pressed', isIn ? 'true' : 'false');
      toggleLabel.textContent = isIn ? L.remove : L.add;
      priceEl.textContent = isIn ? '' : money(cents(viewing), sym);
      if (photoState) photoState.hidden = !isIn;
    }

    /* ---------- selectie ---------- */
    function render(newId) {
      var ids = Object.keys(picked);
      var sum = 0;
      list.innerHTML = '';
      ids.forEach(function (id) {
        var p = picked[id];
        sum += p.cents || 0;
        var li = document.createElement('li');
        if (id === newId) li.className = 'is-new';
        li.innerHTML = (p.swatch || '') +
          '<span class="name"><span>' + esc(p.name) + '</span>' + (p.family ? '<small>' + esc(p.family) + (p.finish ? ' · ' + esc(p.finish) : '') + '</small>' : '') + '</span>' +
          '<span class="price">' + esc(p.price) + '</span>' +
          '<button type="button" class="rm" data-rm="' + esc(id) + '" aria-label="' + esc(p.name) + ' verwijderen">×</button>';
        list.appendChild(li);
      });
      var n = ids.length;
      countEl.textContent = n;
      countEl.classList.remove('is-bump');
      if (newId) { void countEl.offsetWidth; countEl.classList.add('is-bump'); }
      totalEl.textContent = money(sum, sym);
      cartBtn.disabled = n === 0;
      cartBtn.textContent = n === 0 ? L.cartEmpty : (n === 1 && L.cartOne ? L.cartOne : fmt(L.cart, { n: n }));
      if (stCount) stCount.textContent = n === 1 ? '1 sample' : n + ' samples';
      if (stTotal) stTotal.textContent = money(sum, sym);
      if (stCart) stCart.textContent = L.cart.split('\u00b7')[0].trim() || cartBtn.textContent;
      selection.classList.toggle('has-items', n > 0);
      if (tipEl) {
        var from = parseInt(tipEl.getAttribute('data-op2-tip-from'), 10) || 4;
        tipEl.classList.toggle('is-hot', n >= from);
      }
      swatches.forEach(function (b) {
        var on = !!picked[b.getAttribute('data-vid')];
        b.classList.toggle('is-picked', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      syncToggle();
      paintSticky();
      try { sessionStorage.setItem('sfOpPicked', JSON.stringify(picked)); } catch (e) {}
    }

    function announce(tpl, btn) {
      if (!live) return;
      live.textContent = '';
      var n = Object.keys(picked).length;
      setTimeout(function () { live.textContent = fmt(tpl, { name: btn.getAttribute('data-name') || '', n: n }); }, 30);
    }

    function add(btn) {
      touched = true;
      var id = btn.getAttribute('data-vid');
      var sw = btn.querySelector('.sf-swatch');
      picked[id] = {
        name: btn.getAttribute('data-name'),
        family: btn.getAttribute('data-family') || '',
        finish: btn.getAttribute('data-finish') || '',
        price: money(cents(btn), sym),
        cents: cents(btn),
        swatch: sw ? sw.outerHTML.replace(' sf-swatch--lg', '') : ''
      };
      render(id);
      announce(L.liveAdded, btn);
    }
    function remove(id) {
      touched = true;
      var btn = byId(id);
      delete picked[id];
      render();
      if (btn) announce(L.liveRemoved, btn);
    }
    function toggle(btn) {
      var id = btn.getAttribute('data-vid');
      if (picked[id]) remove(id); else add(btn);
    }

    /* Eén klik op een tegel: in beeld én in je selectie (of eruit). */
    swatches.forEach(function (b) {
      b.addEventListener('click', function () {
        view(b);
        toggle(b);
      });
    });
    toggleBtn.addEventListener('click', function () { if (viewing) toggle(viewing); });
    list.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-rm]');
      if (!rm) return;
      remove(rm.getAttribute('data-rm'));
    });

    function checkout() {
      var ids = Object.keys(picked);
      if (!ids.length) return;
      busy(cartBtn, function () {
        return addItems(ids, urls).then(function () {
          picked = {};
          render();
        });
      });
    }
    cartBtn.addEventListener('click', checkout);
    if (stCart) stCart.addEventListener('click', checkout);

    /* ---------- mobiele balk ---------- */
    var mq = window.matchMedia('(max-width: 749px)');
    var selectionOut = false;
    /* Een selectie die uit de sessie is teruggehaald (eerder gekozen, nog niet besteld) toont de balk pas
       zodra je op deze pagina zelf iets kiest of weghaalt, zodat er niet ongevraagd '2 samples' staat. */
    var touched = false;
    function paintSticky() {
      if (!sticky) return;
      var on = mq.matches && selectionOut && touched && Object.keys(picked).length > 0;
      sticky.classList.toggle('is-on', on);
      sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      document.body.classList.toggle('sf-sb-sticky-on', on || !!document.querySelector('.sf-sbc__sticky:not([hidden])'));
    }
    /* Op scroll meten in plaats van IntersectionObserver: die zwijgt in sommige (ingebedde) browsers. */
    var stickyTimer = null;
    function measureSticky() {
      stickyTimer = null;
      if (!sticky || !selection) return;
      var r = selection.getBoundingClientRect();
      selectionOut = r.bottom < 0 || r.top > window.innerHeight;
      paintSticky();
    }
    function queueSticky() { if (stickyTimer == null) stickyTimer = setTimeout(measureSticky, 80); }
    window.addEventListener('scroll', queueSticky, { passive: true });
    window.addEventListener('resize', queueSticky);
    if (mq.addEventListener) mq.addEventListener('change', queueSticky);
    else if (mq.addListener) mq.addListener(queueSticky);

    /* ---------- start ---------- */
    render();
    measureSticky();
    var initial = root.getAttribute('data-op-initial');
    var startGrid = initial ? root.querySelector('[data-op2-grid="' + initial + '"]') : null;
    var start = (startGrid || root).querySelector('[data-op2-swatch].is-picked:not([disabled])') ||
      (startGrid || root).querySelector('[data-op2-swatch]:not([disabled])') ||
      root.querySelector('[data-op2-swatch]:not([disabled])');
    if (start) {
      var g = start.getAttribute('data-grid');
      if (g) activateTab(g);
      view(start);
    }
    /* Animaties pas na de eerste tekening, anders springt alles wat al gekozen was bij het laden. */
    setTimeout(function () { root.classList.add('is-live'); }, 60);

    /* Anker #werkbladen en het antwoord Werkbladen in de keuzehulp. */
    function hashTab() {
      if (window.location.hash !== '#werkbladen') return;
      if (!root.querySelector('[data-op2-grid="tops"]')) return;
      openTab('tops');
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    hashTab();
    window.addEventListener('hashchange', hashTab);
    try {
      if (sessionStorage.getItem('sfSbAnswer') === 'tops' && window.location.hash !== '#werkbladen') openTab('tops');
    } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
